import { useTranslation } from 'react-i18next'
import { EditOutlined } from '@ant-design/icons'

function TimeInfoCard({
  task,
  primaryTimeToShow,
  secondaryTimeToShow,
  primaryLabel,
  secondaryLabel,
  typeSecondary,
  isEditOptimalsAvailable,
  setIsModalOpen,
  newOptimalTime,
  setNewOptimalTime,
  setEditOptimalsAvailable,
  canUpdateTaskOptimals
}) {
  const { t } = useTranslation()

  return (
    <article className={typeSecondary ? 'optimal-time-details secondary-details' : 'optimal-time-details'}>
      <div>
        <p>{t(secondaryLabel)}:</p>
        {isEditOptimalsAvailable ? (
          <>
            <input
              type='time'
              value={newOptimalTime}
              onChange={(e) => {
                setNewOptimalTime(e.target.value)
              }}
            />
            <span className='optimal-time-apply' onClick={() => setIsModalOpen(true)}>
              {t('jobs.tasks.changeOptimalStart.apply')}
            </span>
          </>
        ) : (
          <>
            {secondaryTimeToShow}
            {task.resources.length === 0 && task.status === 'PROCESSING' && canUpdateTaskOptimals && !typeSecondary && (
              <EditOutlined style={{ color: '#1890FF' }} onClick={() => setEditOptimalsAvailable(true)} />
            )}
          </>
        )}
      </div>
      <p>
        <b>{t(primaryLabel)}:</b>{' '}
        {(task.resources.length === 0) & (task.status === 'PROCESSING')
          ? '--'
          : (task.status === 'DOING') & typeSecondary
          ? t('jobs.tasks.changeOptimalStart.inProgress')
          : primaryTimeToShow}
      </p>
    </article>
  )
}

export { TimeInfoCard }
